<template>
    <div class="home">
        <v-container fill-height class="pt-0">
            <h2 class="mb-3">Alert Stat Details</h2>
            <report-filter :report-filter-override="reportFilterOverride" ref="reportFilter"></report-filter>

            <v-row v-for="row in reportLayouts" :key="row">
                <v-col cols="12" :key="chart.chartId" v-for="chart in row.cols" :md="chart.colSpan" xs="12" sm="12">
                    <chart-view :chart-id="chart.chartId"
                                :key="chart"
                                :chart-type="chart.chartType"
                                @on-operator-select="onOperatorSelect"
                                @on-severity-select="onSeveritySelect"
                                :report-filter-override="reportFilterOverride"
                                :report-layout-id="chart.reportLayoutId"
                                @replaced="onReplaced"></chart-view>
                </v-col>
            </v-row>
            <!--<v-row>
                <v-col cols="12">
                    <v-btn outlined
                           rounded
                           @click="isChartSelectorVisible = !isChartSelectorVisible"
                           text>
                        EDIT MODE
                    </v-btn>
                </v-col>
            </v-row>-->
        </v-container>
    </div>
</template>

<script>
    import ChartView from "../../components/charts/ChartView"
    import ReportFilter from "../../components/reports/ReportFilter"
    import ReportLayoutService from "../../services/reportLayoutService"
    import moment from 'moment';

    export default {
        name: 'PostSevData',
        data: function () {
            return {
                accessToken: null,
                reportLayouts: [],
                reportFilterOverride: {
                    startDate: moment().subtract(30, "days").format(moment.HTML5_FMT.DATE),
                    startTime: "00:00",
                    endDate: moment().format(moment.HTML5_FMT.DATE),
                    endTime: "23:59",
                    selectedOperatorBrands: [],
                    selectedIncidentTypes: [],
                    selectedResponsibleTeams: [],
                    selectedSites: [],
                    startDateAndTime: null,
                    endDateAndTIme: null,
                    name: "",
                    entity: ""
                }
            }
        },
        components: {
            ReportFilter,
            ChartView
        },
        watch: {
            deep: true,
            immediate: true,
            "$route.query": {
                handler() {
                    this.setup();
                },
                deep: true
            },
            reportFilterOverride: {
                handler() {
                    if (this.$route.query.name) {
                        this.$router.replace({
                            name: 'AlertStatDetails', query:
                            {
                                entity: this.$route.query.entity,
                                startDate: this.$route.query.startDate,
                                endDate: this.$route.query.endDate,
                            }
                        });
                    }
                },
                deep: true
            }
        },
        methods: {
            async setup() {
                this.accessToken = this.$auth.getAccessToken();
                await this.getReportLayout("AlertStatDetails");

                if (this.$route.query.entity) {
                    this.reportFilterOverride.entity = this.$route.query.entity;
                }

                if (this.$route.query.startDate) {
                    this.reportFilterOverride.startDate = this.$route.query.startDate;
                }

                if (this.$route.query.endDate) {
                    this.reportFilterOverride.endDate = this.$route.query.endDate;
                }
            },
            async getReportLayout(name) {
                let results = await ReportLayoutService.getReportLayoutsByName(name, false, this.accessToken);

                let reportRows = [];

                results.forEach(function (item) {

                    if (!reportRows[item.row - 1]) {
                        reportRows.push({
                            cols: [
                                {
                                    chartId: item.chartId,
                                    chartType: item.chartType,
                                    reportLayoutId: item.id,
                                    colSpan: item.colSpan
                                }
                            ]
                        });
                    }
                    else {
                        reportRows[item.row - 1].cols.push({
                            chartId: item.chartId,
                            chartType: item.chartType,
                            reportLayoutId: item.id,
                            colSpan: item.colSpan
                        });
                    }

                });

                this.reportLayouts = reportRows;
            },
            getCols(cols) {
                return Math.floor(12 / cols);
            },
            onChartSelectorClose() {
                this.isChartSelectorVisible = false;
            },
            onOperatorSelect(evt) {
                this.reportFilterOverride.selectedOperatorBrands = [];

                var operatorBrands = this.$refs.reportFilter.getOperatorBrands();

                operatorBrands.forEach(brand => {
                    if (brand.toLowerCase() === evt.toLowerCase()) {
                        this.reportFilterOverride.selectedOperatorBrands.push(brand);
                    }
                });
            },
            onSeveritySelect(evt) {
                this.reportFilterOverride.selectedIncidentTypes = [];
                this.reportFilterOverride.selectedIncidentTypes.push(evt);
            },
            onReplaced() {
                this.reportLayouts = [];
                this.getReportLayout("PostSevDetails");
            }
        },
        created() {
            this.setup();
        }
    }
</script>
